import { render, staticRenderFns } from "./BoxInfo.vue?vue&type=template&id=23142f83&scoped=true&"
import script from "./BoxInfo.vue?vue&type=script&lang=js&"
export * from "./BoxInfo.vue?vue&type=script&lang=js&"
import style0 from "./BoxInfo.vue?vue&type=style&index=0&id=23142f83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23142f83",
  null
  
)

export default component.exports